const $win = $(window);
const initSlider = () => {
  const config = {
    infinite: false,
    prevArrow: `
      <a href="#" class="slick-arrow slick-prev">
        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1.5332L5.5 6.19987L1 1.5332" stroke="#111e90" stroke-width="0.5"/>
        </svg>
        Previous
      </a>
    `,
    nextArrow: `
      <a href="#" class="slick-arrow slick-next">
        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1.5332L5.5 6.19987L1 1.5332" stroke="#111e90" stroke-width="0.5"/>
        </svg>
        Next
      </a>
    `
  };

  $('.js-post-related-products-slider')
    .not('.slick-initialized')
    .slick(config);
};

$win.on('load resize orientationchange', function() {
  if ($win.width() < 768) {
    initSlider();
  } else {
    if ($('.js-post-related-products-slider.slick-initialized').length) {
      $('.js-post-related-products-slider').slick('unslick');
    }
  }
});
